import { useEffect, useState } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { BackButton } from "../../../components/buttons/backButton";
import { SignUpConfirmEmail } from "./signUpConfirmEmail";
import { SignUpCooperative } from "./signUpCooperative";
import { SignUpMember } from "./signUpMember";
import { SignUpType } from "./signUpType";

export type SignupType = "member" | "cooperative";

export type SignupStep = "signup" | "confirm-mail";

export const SignUp = ({ signUpType }: { signUpType: SignupType }) => {
  const [step, setStep] = useState<SignupStep>("signup");

  const [params] = useSearchParams();

  const navigate = useNavigate();

  const goBack = () => {
    if (step === "signup") {
      navigate("/auth/sign-in");
    }
  };

  useEffect(() => {
    setStep((params.get("step") as SignupStep) || "signup");
  }, [params]);

  if (!["member", "cooperative", "", null, undefined].includes(signUpType)) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  return (
    <div className="w-full max-w-[327px]">
      {step === "signup" ? (
        <BackButton
          text={step === "signup" && signUpType !== null ? "Login" : "Back"}
          onClick={() => {
            goBack();
          }}
          className="mb-7"
        />
      ) : undefined}

      {step === "signup" && !signUpType && <SignUpType />}

      {step === "signup" && signUpType === "member" && <SignUpMember />}

      {step === "signup" && signUpType === "cooperative" && (
        <SignUpCooperative />
      )}

      {step === "confirm-mail" && <SignUpConfirmEmail />}
    </div>
  );
};
